const _HOST = HOST;
export { _HOST as HOST };
